export default __webpack_public_path__ + "static/media/logout.37ec43da.svg";